import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeDisplayStatus from "./chargeDisplayStatus";
import ChargeOrderStatus from "./chargeOrderStatus";
import ChargePermittedActionsResponse from "./chargePermittedActionsResponse";
import FailedRefundReason from "./failedRefundReason";
import PaymentType from "./paymentType";
import RefundDisplayStatus from "./refundDisplayStatus";
import SourceType from "./sourceType";
import VehicleResponse from "./vehicleResponse";
import { enumValue } from "utils/enumerable";
import Enum from "./enum";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class ChargeResponse {
  /**
   * Charge ID.
   */
  @observable
  chargeId!: string;

  /**
   * Charge order ID or null.
   * @example
   * 170477d7-3d45-4180-a350-04e604069209
   */
  @observable
  chargeOrderId!: string;

  /**
   * Date and time when order for charge was created.
   */
  @observable
  @Type(() => Date)
  chargeOrderCreatedAt!: Date;

  /**
   * Date and time when order for charge was confirmed.
   */
  @observable
  @Type(() => Date)
  chargeOrderConfirmedAt?: Date;

  @observable
  orderStatus!: ChargeOrderStatus;

  @observable
  orderSourceType!: SourceType;

  @observable
  paymentType?: PaymentType;

  /**
   * Order identifier (variable symbol).
   */
  @observable
  orderIdent!: number;

  /**
   * Price list item Id.
   * @example
   * 62798d34-804a-47e4-8274-b24e64e89dbc
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  /**
   * Charge is valid since this date and time.
   * @example
   * 07/21/2021 10:30:45 +00:00
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Charge is valid until this date and time.
   * @example
   * 08/21/2021 10:30:44 +00:00
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  /**
   * Charge vehicle registration was changed with this submission date.
   */
  @observable
  @Type(() => Date)
  vehicleRegistrationChangeSubmissionDate?: Date;

  /**
   * E-mail address assigned to charge or null.
   */
  @observable
  emailAddress?: string;

  /**
   * Notification phone number.
   */
  @observable
  notificationPhoneNumber?: string;

  /**
   * E-mail address was changed.
   */
  @observable
  wasEmailChanged!: boolean;

  /**
   * The charge is a part of bulk order.
   */
  @observable
  isBulkChargeOrder!: boolean;

  @observable
  refundDisplayStatus?: RefundDisplayStatus;

  /**
   * Is true if refund is partial.
   */
  @observable
  isPartiallyRefunded!: boolean;

  @observable
  failedRefundReason?: FailedRefundReason;

  @observable
  chargeDisplayStatus!: ChargeDisplayStatus;

  /**
   * Indicates if license plate or country was changed during validity.
   */
  @observable
  wasVehicleChangedDuringValidity!: boolean;

  /**
   * Official record Id used for refund/vehicle registration change.
   */
  @observable
  officialRecordId?: string;

  @observable
  @Type(() => ChargePermittedActionsResponse)
  permittedActions!: ChargePermittedActionsResponse;
}

export default class Charge extends ChargeResponse {
  phoneNumber?: string;

  price?: number;

  fuelTypeId?: string;

  fuelType?: string;

  chargeType?: string;

  chargeTypeId?: string;

  @enumValue("fuel_types", "fuelTypeId")
  fuelTypeEnum?: Enum;

  @enumValue("charge_types", "chargeTypeId")
  chargeTypeEnum?: Enum;
}
